import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_vlan",
  "use": "icon-icon_vlan-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol viewBox=\"0 0 20 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_vlan\">\n    <path d=\"M16 0V3H0V5H16V8L20 4L16 0ZM4 10L0 14L4 18V15H20V13H4V10Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol